import { PRIVATE as XRFRAME_PRIVATE } from "webxr-polyfill/src/api/XRFrame";
import { PRIVATE as XRSESSION_PRIVATE } from "webxr-polyfill/src/api/XRSession";

const NON_ACTIVE_FRAME_MESSAGE =
  "XRFrame access outside the callback that produced it is invalid.";

const SESSION_TRACKED_ANCHORS = Symbol("@@launch-webxr/SessionTrackedAnchors");
const FRAME_TRACKED_ANCHORS = Symbol("@@launch-webxr/FrameTrackedAnchors");

export function ensureActiveFrame(frame) {
  if (frame?.[XRFRAME_PRIVATE] && !frame[XRFRAME_PRIVATE].active) {
    throw new DOMException(NON_ACTIVE_FRAME_MESSAGE, "InvalidStateError");
  }
}

export function getTrackedAnchorsForSession(session) {
  if (!session[SESSION_TRACKED_ANCHORS]) {
    session[SESSION_TRACKED_ANCHORS] = new Set();
  }

  return session[SESSION_TRACKED_ANCHORS];
}

export function getTrackedAnchorsForFrame(frame) {
  if (!frame[FRAME_TRACKED_ANCHORS]) {
    const anchors = new Set();

    for (const anchor of getTrackedAnchorsForSession(frame.session)) {
      if (!anchor.deleted) {
        anchors.add(anchor);
      }
    }

    frame[FRAME_TRACKED_ANCHORS] = anchors;
  }

  return frame[FRAME_TRACKED_ANCHORS];
}

export function attachAnchorToSession(anchor, session) {
  if (!anchor) {
    return anchor;
  }

  anchor._session = session;
  anchor._arKitWrapper = session?.[XRSESSION_PRIVATE]?.device?._arKitWrapper ?? null;

  return anchor;
}

export function trackAnchor(anchor, session) {
  if (!anchor) {
    return anchor;
  }

  attachAnchorToSession(anchor, session);
  getTrackedAnchorsForSession(session).add(anchor);

  return anchor;
}

export function untrackAnchor(anchor) {
  if (!anchor?._session) {
    return;
  }

  getTrackedAnchorsForSession(anchor._session).delete(anchor);
}
